import { useMemo } from "react"
import { Field, Form } from "web/components"

export function FieldSelector({
  allFields,
  potentialNewFields,
  sortedFields,
  onAddField,
}) {
  function handleFormChange(formValue) {
    if (!formValue.field) return
    const field = sortedFields.find(
      (field) => field.key === formValue.field.value
    )
    onAddField(field)
  }

  const customFieldSelector = useMemo(() => {
    function getFieldLabel(targetField) {
      const otherFieldsWithSameName = !!allFields.find(
        (field) =>
          field.label === targetField.label && field.key !== targetField.key
      )

      return otherFieldsWithSameName
        ? targetField.subject_type_label + " " + targetField.label
        : targetField.label
    }

    return [
      {
        key: "field",
        name: "field",
        kind: "Lookup",
        lookup_values: potentialNewFields.map((field) => ({
          value: field.key,
          label: getFieldLabel(field),
        })),
      },
    ]
  }, [allFields, potentialNewFields])

  return (
    <Form
      value={{}}
      onChange={handleFormChange}
      fields={customFieldSelector}
      render={() => {
        return (
          <>
            <h4 className="mb-0.5 text-sm text-neutral-5">
              Select Field to Add
            </h4>
            <Field fieldKey="field" />
          </>
        )
      }}
    />
  )
}
